


























import { Component, Vue } from 'vue-property-decorator'
import { AloCours, getDefaultAloCours } from '@/models/alo/AloCours'
import { getImageUrl } from '@/utils/images'


@Component({
  name:"ListeTuileCoursItem",
  components: {    
  },
  props:{    
    cours:{
      type:Object,
      required:true,
      default:getDefaultAloCours()
    },
    resas:{
      type:Array,
      default:()=>[]
    },
    reserving:{
      type:Boolean,
      default:false
    },
    noresa:{
      type:Boolean,
      default:false
    }
  }
})
export default class ListeTuileCoursItem extends Vue {    
  cours!:AloCours  
  resas!:Array<number>
  noresa!:boolean
  reserving!:boolean
  showInscription:boolean = false
  selectedCours:AloCours = getDefaultAloCours()
  selectedUsrId:number = 0

  get nbResa() {
    return this.resas.filter(r => r == this.cours.id).length
  }

  get apartirInfos(){
    return this.activityDic[this.cours.acyId]?.acyAge == 0?"A partir de 6 mois":(this.activityDic[this.cours.acyId]?.acyAge?`A partir de ${this.activityDic[this.cours.acyId]?.acyAge} ans`:"")
  }        

  get getImageUrl(){
    return getImageUrl
  }

  get participants()  {
    return this.$store.myGetters.user.membres
  }

  reserver(){
    this.$emit('reserver')
  }

  get activityDic(){
    return this.$store.myGetters.activityDic
  }
}
